import { keyframes } from "@emotion/react";
import { Box } from "@mui/material";
import { ReactNode } from "react";

// Define keyframes using Emotion so they're injected into the document
// where the component renders (works in iframes with Emotion configured)
const pulseRing = keyframes`
    0% {
        transform: scale(0.33);
    }
    80%, 100% {
        opacity: 0;
    }
`;

const pulseDot = keyframes`
    0%, 50%, 100% {
        transform: scale(0);
    }
`;

const PulsingIcon = ({
    children,
    active = true,
    onClick,
    color,
    size = 24,
}: {
    onClick?: () => void;
    active?: boolean;
    children: ReactNode;
    color?: string;
    size?: number;
}) => {
    return (
        <Box
            sx={(theme) => ({
                ...pulsingStyle(color || theme.palette.secondaryRed.main, size),
                "&::before": active
                    ? pulsingStyle(color || theme.palette.secondaryRed.main, size)["&::before"]
                    : "",
                cursor: onClick ? "pointer" : "auto",
            })}
            onClick={onClick}
        >
            {children}
        </Box>
    );
};

const pulsingStyle = (color: string, size: number) => ({
    width: size,
    height: size,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // zIndex: "2", //REVIEW this is causing overlap on CoW Loan form
    "&::before": {
        content: '""',
        top: 0,
        left: 0,
        position: "absolute",
        display: "block",
        width: "300%",
        height: "300%",
        boxSizing: "border-box",
        marginLeft: "-100%",
        marginTop: "-100%",
        borderRadius: 45,
        backgroundColor: color,
        animation: `${pulseRing} 1.25s cubic-bezier(0.215, 0.61, 0.355, 1) infinite`,
        zIndex: 1,
    },
    "&::after": {
        content: '""',
        position: "absolute",
        left: 0,
        top: 0,
        display: "block",
        width: "100%",
        height: "100%",
        borderRadius: 15,
        boxShadow: "0 0 8px rgba(0, 0, 0, 0.3)",
        animation: `${pulseDot} 1.25s cubic-bezier(0.455, 0.03, 0.515, 0.955) -0.4s infinite`,
        zIndex: 1,
    },
});

export default PulsingIcon;
